export const GET_SELECTED_DOCUMENT = ' GET_SELECTED_DOCUMENT';
export const GET_STUDENTS_IN_DOCUMENTS = ' GET_STUDENTS_IN_DOCUMENTS';
export const GET_LOOKUP_SPEEDE_DOCUMENT = ' GET_LOOKUP_SPEEDE_DOCUMENT';
export const UPDATE_IMPORT_DETAILS = ' UPDATE_IMPORT_DETAILS';
export const UPDATE_COURSE_PARAMETERS = 'UPDATE_COURSE_PARAMETERS'

